module.exports = "/images/RefundPolicy.svg?a238dc886d0afb65f04db2f18c2f5f37";